var _rect, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgSetur = function SvgSetur(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.283,
    y: 0.138,
    width: 22,
    height: 22,
    rx: 4,
    fill: "#E83843"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.797 10.625C13.769 9.876 12 9.397 12 9.397l-.232 1.382L9.69 8.305l2.77-1.66-.24 1.44c.918.124 1.931.61 2.554.916l.254.125.547-3.274c-.078-.043-.162-.084-.241-.126a7.369 7.369 0 0 0-3.035-.901c-2.665-.21-5.442 1.213-5.671 4.136-.102 1.293.488 2.23 1.402 2.845 1.249.732 3.382 1.163 3.382 1.163l.22-1.413 2.084 2.474-2.765 1.666.228-1.355c-1.69-.179-3.219-.926-3.938-1.38l-.595 3.513c1.143.525 2.448.883 3.632.974 2.649.212 5.428-1.03 5.658-3.969.1-1.285-.348-2.203-1.14-2.854Z",
    fill: "#fff"
  })));
};

export default SvgSetur;